export const DIRECTIVE_NAME = AutocompleteMultiselectValidator.DIRECTIVE_NAME = 'ktAutocompleteMultiselectValidator';
export default function AutocompleteMultiselectValidator() {
    return {
        restrict: 'A',
        priority: 1,
        require: ['ngModel'],
        link: function($scope, elem, $attrs, [ngModelCtrl]) {
            const locationValue = $attrs[`${DIRECTIVE_NAME}Location`];
            const requiredValue = $attrs[`${DIRECTIVE_NAME}Required`];
            $scope.$watch(getModelValue, validate, true);

            function validate() {
                ngModelCtrl.$setValidity('required', !$scope.$eval(requiredValue) || $scope.$eval(locationValue).length !== 0);
            }

            function getModelValue() {
                return $scope.$eval(locationValue);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/directives/autocomplete-multiselect-kt.validator.js